import { AppState } from '../models/state/appState';

/**
 * Selects the current mvno buddle.
 * @param state The application state.
 */
export function selectMvnoBundle(state: AppState) {
  return state.mvnoBundle;
}
